import createIcon from '../../createIcon';

/**
 * @component @name SignalCellularAlt
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTYuNSA0SDE5LjVWMjBIMTYuNVY0Wk00LjUgMTRINy41VjIwSDQuNVYxNFpNMTAuNSA5SDEzLjVWMjBIMTAuNVY5WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SignalCellularAlt = createIcon('SignalCellularAlt', [
  [
    'path',
    { d: 'M16.5 4H19.5V20H16.5V4ZM4.5 14H7.5V20H4.5V14ZM10.5 9H13.5V20H10.5V9Z', key: '1nbb86' },
  ],
]);

export default SignalCellularAlt;
